// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__p0YhQ","subheader":"ReorderModal_subheader__moLuD","listWrap":"ReorderModal_listWrap__tLJxC"};